<template>
  <div class="home">
    <hero />
    <about />
    <work />
    <skills />
    <contact />
    <app-footer />
  </div>
</template>

<script>
import Hero from "../sections/Hero.vue";
import About from "../sections/About.vue";
import Work from "../sections/Work.vue";
import Skills from "../sections/Skills.vue";
import Contact from "../sections/Contact.vue";
import AppFooter from "../components/AppFooter.vue";

export default {
  name: "Home",
  components: {
    Hero,
    About,
    Work,
    Skills,
    Contact,
    AppFooter
  }
};
</script>

<style scoped>
.home {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
